import { Link } from "react-router-dom";
import CompanyListTable, {
  formatCreated,
} from "../../components/AdminDashboard/CompanyListTable";

const COLUMNS = [
  {
    header: "Company Name",
    render: (row) => (
      <Link
        to={`/admin-dashboard/buyers/${row?._id}`}
        style={{ cursor: "pointer", textDecoration: "underline" }}
      >
        {row?.name}
      </Link>
    ),
  },
  { header: "Name", render: (row) => row?.contactName },
  { header: "Industry", render: (row) => row?.industry },
  { header: "Created", preWrap: true, render: (row) => formatCreated(row?.createdAt) },
  { header: "Location", render: (row) => row?.address },
];

const Buyer = () => (
  <CompanyListTable
    type="Buyer"
    title="Buyer"
    emptyLabel="buyers"
    columns={COLUMNS}
  />
);

export default Buyer;
